import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import { servedSectionEvent } from '../../instrumentation/instrumentation';
import { TitleSemicircle } from '../ExploreNames/styled';
import {
  PinkSlant,
  UniqueBabySec,
  UniqueTitle,
  UniqueTitleSpan,
} from './styled';
import UniqueNameCard from './UniqueNameCard';

export default function UniqueBabyName(props) {
  const { babyNamesBoy, babyNamesGirl, home } = props;
  const router = useRouter();
  let headingGirlNames = `Most popular Baby girl names of ${new Date().getFullYear()}`;
  let headingBoyNames = `Most popular Baby boy names of ${new Date().getFullYear()}`;

  const viewAllRedirection = (heading) => {
    router.push(
      // router.route +
      `/babynames/unique-baby-names/${heading}` + window.location.search,
    );
  };
  useEffect(() => {
    let card_id_girl = babyNamesGirl?.map((data) => data.id);
    let card_id_boy = babyNamesBoy?.map((data) => data.id);
    servedSectionEvent(home, headingGirlNames, card_id_girl);
    servedSectionEvent(home, headingBoyNames, card_id_boy);
  }, []);
  return (
    <>
      {' '}
      <UniqueBabySec background={'#fad0d052'}>
        <UniqueTitle>
          <TitleSemicircle unique></TitleSemicircle>{' '}
          <UniqueTitleSpan>{headingGirlNames}</UniqueTitleSpan>
        </UniqueTitle>
        <UniqueNameCard
          heading="Girl"
          redirect={viewAllRedirection}
          names={babyNamesGirl}
          home={home}
          headingName={headingGirlNames}
        />

        <PinkSlant
          src="/images/pinkslant.svg"
          alt="pink-slant"
          loading="lazy"
        />
      </UniqueBabySec>
      <UniqueBabySec background={'#effafc'}>
        <UniqueTitle>
          <TitleSemicircle unique blue></TitleSemicircle>{' '}
          <UniqueTitleSpan>{headingBoyNames}</UniqueTitleSpan>
        </UniqueTitle>
        <UniqueNameCard
          heading="Boy"
          redirect={viewAllRedirection}
          names={babyNamesBoy}
          home={home}
          headingName={headingBoyNames}
        />
        <PinkSlant
          src="/images/blu_slant.svg"
          alt="blue-slant"
          loading="lazy"
        />
      </UniqueBabySec>
    </>
  );
}
